<template>
  <div class="weapp-box">
        <wx-open-launch-weapp
          id="launch-btn"
          username="gh_0402f3d6ac1d"
          @launch="handleLaunchFn" 
          @error="handleErrorFn"
          path="pages/other/other.html?scene=71700">
          <script type="text/wxtag-template">   
              <button
              style="width: 100px; height: 40px; text-align: center; font-size: 14px; display: flex; align-items: center; justify-content: center;margin: 0 auto;border: none; border-radius: 4px; background-color: #07c160;">观看视频</button>
          </script>
   </wx-open-launch-weapp>
  </div>
</template>
<script>
import util from "../../src/util/util.js"
export default {
    data(){
      return{
        weappTab: ''
      }
    },
    mounted(){
      let status = util.getRunState();
      console.log('status22222',status)
      if(status.isWeixin){
          this.getInitUrl((data) => {
            console.log("data----",data)
            wx.config({
              appId: data.appId, // <!-- replace -->
              timestamp: data.timestamp, // 必填，填任意数字即可
              nonceStr: data.nonceStr, // 必填，填任意非空字符串即可
              signature: data.signature, // 必填，填任意非空字符串即可
              jsApiList: ['wx-open-launch-weapp'], // 必填，随意一个接口即可 
              openTagList:['wx-open-launch-weapp'], // 填入打开小程序的开放标签名
            });
            wx.ready(function () {
              console.log("ready+++++++++++++++")
            });
            wx.error(function (res) {
              console.log("errrrrrrry+++++++++++++++",res)
            });
          })
      }
    },
    methods: {
      handleLaunchFn(){
        console.log("handleLaunchFn")
      },
      handleErrorFn(){
        console.log("handleErrorFn")
      },
      // 获取微信js api config
      getInitUrl(callback){
        var totalUrl = 'https://api.milinzone.com/feeds/wechat/getWeChatJsApiConfig';
        var getUrl = window.location.origin+ '/'
        // var getUrl = 'https://www.milinzone.com/';
        console.log('getUrlsss',getUrl)
        var sendData = {
          "url": getUrl
        };
        this.axios({
          method: "POST",
          url: totalUrl,
          headers: {
            'Content-Type': 'application/json'
          },
          data: sendData
        }).then((res) => {
          console.log(res,'res')
          if(res.data && res.data.code == 0){
            let data = res.data.data;
            callback && callback(data)
          }
        }).catch((err) => {
          console.log("err",err)
        })
      }
    }
}
</script>
<style lang="scss">
    .weapp-box{
      width: 100%;
      .weapp-tab{
        width: 100px;
        height: 40px;
      }
    }
</style>

